<style lang="scss" scoped>
.inbound-info > span {
	display: inline-block;
	width: 20%;
	padding: 6px 0;
}
</style>

<template>
	<section class="margin-15 relative">
        <div class="inbound-info" v-if="type == 'query'">
            <span>SKU种类合计：{{planQty}}</span>
            <span>计划下架总数：{{planSoldOut}}</span>
            <span>实际下架总数：{{actualSoldOut}}</span>
            <span>计划上架总数：{{planPutaway}}</span>
            <span>实际上架总数：{{actualPutaway}}</span>
        </div>
		<template v-else>
			<div style="margin-bottom: -20px">
				<vFormItem label-width="auto" inline label="换标前SKU：" class="margin-right-10" required prop="sku">
                    <div style="cursor: pointer" @click="handleSkuErp">
                        <vInput v-model="formData.sku" readonly suffix="search" @on-icon-click="handleSkuErp"></vInput>
                    </div>
				</vFormItem>
                <vFormItem label-width="auto" inline label="可用库存：" class="margin-right-10">
					{{formData.inventoryAvailable || 0}}
				</vFormItem>
				<vFormItem label-width="auto" inline label="下架数量：" class="margin-right-10" required prop="qty">
					<vInputNumber clearable v-model="formData.qty" :min="1" math="round" @on-change="changeNewQty"/>
				</vFormItem>
                <vFormItem label-width="auto" inline label="换标后SKU：" class="margin-right-10" required prop="newSku">
                    <div style="cursor: pointer" @click="handleSkuErpNew">
                        <vInput v-model="formData.newSku" readonly suffix="search" @on-icon-click="handleSkuErpNew"></vInput>
                    </div>
				</vFormItem>
                <vFormItem label-width="auto" inline label="上架数量：" class="margin-right-10" required prop="newQty">
					<vInputNumber v-if="baseData.businessType == 0" clearable v-model="formData.qty" :min="1" math="round" disabled/>
					<vInputNumber v-else clearable v-model="formData.newQty" :min="1" math="round" />
				</vFormItem>
				<vButtonGroup class="inline">
					<vButton theme="primary" @click="addItem(formData)">{{$t('global.common.add',{defaultValue:'添加'})}}</vButton>
					<vButton @click="handleUploadData">{{$t('global.common.import',{defaultValue:'导入'})}}</vButton>
					<vButton @click="clearAll">{{$tc('global.common.clear',2,{defaultValue:'清空'})}}</vButton>
				</vButtonGroup>
			</div>
		</template>
		<vTable
			style="max-height:200px;overflow:auto"
			class="margin-top-10"
			:columns="columns"
			:data="dataList"
            border
		></vTable>
		<compModal
			v-model="modalProps.show"
			v-bind="modalProps"
			@on-close="modalProps.show=false"
			@on-confirm="modalProps.show=false"
		>
			<component
				v-if="modalProps.component"
				:is="modalProps.component"
				v-bind="modalProps.props"
				@on-close="modalProps.show=false"
				v-on="modalProps.on"
			/>
		</compModal>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</section>
</template>

<script>
import { HttpUploadSku } from '@/service/misc';

import compErpsku from './erpsku'

export default {
	props: ['data', 'baseData', 'querytype', 'activeid', 'isManage'],
	components: {
		compFormEdit: () => import("@components/templates/formedit"),
		compUpload: () => import("@components/templates/upload"),
		compModal: () => import("@components/templates/modal"),
		compErpsku,
	},
	data() {
		return {
			loading: false,
			type: this.querytype || this.$route.params.type,
			id: this.activeid || this.$route.query.id,
			formData: {},
			dataList: this.data || [],
            baseData1: this.baseData || [],
			erpSkuData: {},
			modalProps: {
				show: false,
				formdata: null,
			},
            planQty: 0,
            planSoldOut: 0,
            actualSoldOut: 0,
            planPutaway: 0,
            actualPutaway: 0,
		}
	},
	watch: {
        activeid (activeid) {
            if (!activeid) return;
            this.id = activeid;
        },
		data(val) {
			this.dataList = val;
		},
        "baseData.businessType"(){
            this.formData = {}
        },
        baseData(val){
            this.baseData1 = val;
            const productList = val.changeLabelPlanItemEntities || []
            this.planQty = productList.length;
            productList.map(item=>{
                this.planSoldOut += item.qty;
                this.actualSoldOut += item.processQty;
                this.planPutaway += item.newQty;
                this.actualPutaway += item.newProcessQty;
            })
        }
	},
	computed: {
		columns() {
			return [
                {
                    title: "换标前SKU",
                    key: 'sku',
                    render: (h, { row }) => {
                        return <div>{row.sku}</div>
                    }
                },
                {
                    title: "换标前SKU名称中/英",
                    key: 'productName',
                    width: this.type == 'query' ? 0 : 240,
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.productName || '--'}</div>
                            <div>{row.productNameEn || '--'}</div>
                        </div>
                    }
                },
				{
                    title: this.type == 'query' ? "计划下架数量" : "下架数量",
                    width: 120,
                    key: 'qty'
                },
                {
                    title: "实际下架数量",
                    width: this.type == 'query' ? 120 : 0,
                    key: 'processQty'
                },
                {
                    title: "换标后SKU",
                    key: 'newSku',
                },
                {
                    title: "换标后SKU名称中/英",
                    width: this.type == 'query' ? 0 : 240,
                    render: (h, { row }) => {
                        return <div>
                            <div>{row.newProductName || '--'}</div>
                            <div>{row.newProductNameEn || '--'}</div>
                        </div>
                    }
                },
                {
                    title: this.type == 'query' ? "计划上架数量" : "上架数量",
                    width: 120,
                    key: 'newQty',
                },
                {
                    title: "实际上架数量",
                    width: this.type == 'query' ? 120 : 0,
                    key: 'newProcessQty'
                },
                {
                    title: this.$t('global.common.operation', { defaultValue: "操作" }),
                    width: this.type == 'query' ? 0 : 120,
                    align: 'center',
                    render: (h, { row }) => {
                        return h('Button', {
                            nativeOn: {
                                click: () => {
                                    this.removeItems(row)
                                }
                            }
                        }, this.$t('', { defaultValue: "删除" }))
                    }
                },
                {
                    title: '最近更新时间',
                    width: this.type == 'query' ? 200 : 0,
                    key: 'updatedAt'
                }
            ]
		}
	},

	methods: {
        changeNewQty() {
            if(this.baseData.businessType == 0){
                this.formData.newQty = this.formData.qty
            }
        },
		//查询ERPSKU
		handleSkuErp() {
			this.modalProps = {
				show: true,
				title: 'SKU',
				component: "compErpsku",
				showFooter: false,
				width: 1000,
				props: {
                    lineId: this.baseData.lineId,
                    orgWarehouseId: this.baseData.orgWarehouseId,
				},
				on: {
					'on-data': (row) => {
						const { productId = '', sku = '', lineId = '', productName = '', productNameEn = '', inventoryAvailable = ''} = row;
                        this.formData = { ...this.formData, qty: this.formData.qty, inventoryAvailable, productId, sku, lineId, productName, productNameEn};
						this.modalProps.show = false;
					}
				},
			}
		},
        //查询ERPSKU
		handleSkuErpNew() {
			this.modalProps = {
				show: true,
				title: 'SKU',
				component: "compErpsku",
				showFooter: false,
				width: 1000,
				props: {
                    // lineId: this.baseData.lineId,
                    orgWarehouseId: this.baseData.orgWarehouseId,
				},
				on: {
					'on-data': (row) => {
						const { productId = '', sku = '', productName = '', productNameEn = ''} = row;
                        this.formData = { ...this.formData, newQty: this.formData.newQty, newProductId: productId,newSku: sku, newProductName: productName, newProductNameEn: productNameEn};
						this.modalProps.show = false;
					}
				},
			}
		},
		//上传数据
		handleUploadData() {
            if(!this.baseData1.orgWarehouseId){
                this.$Message.warning({
                        content: this.$t('fbb.markchange.check_warehouse', { defaultValue: '请选择仓库！' }),
                        duration: 30,
                        closable: true,
                    });
                return
            }
			this.modalProps = {
				show: true,
				title: this.$t('global.common.import', { defaultValue: '导入数据' }),
				component: "compUpload",
				showFooter: false,
				width: "middle",
                props: {
                    action: process.env.VUE_APP_APIURL_FBB + "/api/v2/changeLabelPlan/importItem",
					data: { orgWarehouseId: this.baseData1.orgWarehouseId },
					name: "multipartFile",
					download: () => {
						this.handleWebfs("/static/template/markchange_sku.xlsx", {}, {
							executor: 'download',
							type: 'url'
						});
					},
				},
				on: {
					'on-success': (row) => {
						Object.values(row.data.changePlanItemModelList || []).forEach((item) => {
							this.addItem({
                                sku: item.sku,
                                qty: item.qty,
                                newSku: item.afterSku,
                                newQty: item.afterQty,
                                productName: item.productName,
                                productNameEn: item.productNameEn,
                                newProductName: item.afterProductName,
                                newProductNameEn: item.afterProductNameEn,
                                lineId: row.data.lineId
                            });
                        })
						this.modalProps.show = false;
					}
				},
			}
		},
		addItem(data) {
			const { sku, qty, newSku, newQty } = data;
			if (sku && qty && newSku && newQty) {
				const erpSkuData = this.dataList.find((item) => {
					return item.sku === sku
				});
				if (erpSkuData) {
                    if( erpSkuData.newSku === newSku ){
                        erpSkuData.qty += qty;
                        erpSkuData.newQty += newQty;
                    }else{
                        this.$VMessage.error(`sku：${sku}不能更换两个不同SKU`)
                        return
                    }
				} else if(newSku === sku){
                    this.$VMessage.error(`换标前后SKU不能相同！`)
                    return
                }else{
					this.dataList.push(data)
				}
                this.update();
				this.formData = {};
				return;
			}
            this.$VMessage.warning(this.$t('', { defaultValue: '请填写必填项！' }));
		},
		clearAll() {
			this.modalProps = {
				show: true,
				title: this.$tc('global.common.clear', 1, { defaultValue: '清空所有' }),
				alert: 'error',
				ajaxRequest: async () => {
                    this.dataList = [];
                    this.update();
					return { message: this.$t('global.common.haveto_empty', { defaultValue: '已清空' }) };
				}
			}
		},
		removeItems(obj) {
			this.modalProps = {
				show: true,
				title: this.$t('global.common.delete', { defaultValue: '删除' }),
				alert: 'warning',
				ajaxRequest: async () => {
					this.dataList = this.dataList.filter((row) => {
						return row.sku !== obj.sku
                    })
                    this.update();
					return { message: this.$t('global.common.have_deleted', { defaultValue: '已删除' }) };
				}
			}
        },
        update(){
            this.$emit('on-update', this.dataList)
        }
	}
}
</script>
